import React from "react"
const Icon=()=>{

    return (<div className="icon_wrapper">
        <div className="icon_inner">
            <div className="inner-1">
            <div className="inner-2"></div>
            <div className="inner-3"></div>
            <div className="circle"></div>
            <div className="dollar">$</div>
            </div>
         
        </div>
    </div>)
}
export default Icon